import { DestroyBase } from "../../../../components/common/ng-destroy-base";
import { CustomKpiExportService } from "../../services/custom-kpi-export.service";
import { EventBusService } from "../../../../services/event-bus.service";
import { TranslateService } from "@ngx-translate/core";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

/**
 * Handles connecting properties to valuation event
 */
@Component({
  selector: 'projects-grid-export-pane',
  templateUrl: './projects-grid-export-pane.component.html',
  styleUrls: ['./projects-grid-export-pane.component.css']
})
export class ProjectsGridExportPaneComponent extends DestroyBase implements OnInit {
  /**
   * Can be closed? (as Infobar in table view)
   */
  @Input() canClose: boolean;

  /**
   * Close pane event
   */
  @Output() closePane: EventEmitter<any> = new EventEmitter();

  /**
   * Should the pane be closed?
   */
  shouldClose = false;

  /**
 * Number of steps (no steps, so 0).. here just for close button
 */
  stepsCount = 0;

  /**
   * Current step
   */
  currentStep = 1;

  /**
   * Close was clicked
   */
  onCloseClicked() {
    this.shouldClose = true;
    setTimeout(() => {
      this.closePane.emit();
    }, 500);
  }

  /**
   * The export options
   */
  public exportOptions = [];

  /**
   * The selected export type
   */
  public selectedExportType = 0;

  /**
   * Constructor
   * @param eventBus
   * @param service
   * @param _translate
   */
  constructor(private eventBus: EventBusService,
    private service: CustomKpiExportService,
    private _translate: TranslateService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.exportOptions = [
      { oid: 0, description: "" },
      { oid: 1, description: this._translate.instant('projectsGridExportPane.exportTypeProjectsTable') },
      { oid: 2, description: this._translate.instant('projectsGridExportPane.exportTypeAdvancedKpi') }
    ];
  }

  /**
   * Export was clicked
   * @returns
   */
  public exportClicked(): void {
    switch (this.selectedExportType) {
      case 1:
        this.defaultExportBehaviour();
        break;
      case 2:
        this.customKpiExport();
        break;
      default:
        return;
    }
  }

  /**
   * Default export: Grid export
   */
  defaultExportBehaviour(): void {
    this.eventBus.broadcastEvent('exportToExcelProjectsGrid');
  }

  /**
   * Custom export
   */
  customKpiExport(): void {
    this.showProgress(true);

    this.service.requestCustomKpiExport().finally(() => {
      this.showProgress(false);
    });
  }

  /**
   * Shows or hides a loading indicator
   * @param show
   */
  showProgress(show: boolean): void {
    this.eventBus.broadcastEvent('project.valuation.showLoader', show);
  }

}
